import IOddDto from '@core/mappers/offer/dtos/IOddDto';
import Odd from '@core/models/offer/Odd';
import AbstractMapper from '@core/utils/mappers/AbstractMapper';

export default class OddMapper extends AbstractMapper<IOddDto, Odd> {
    createTargetObject(dto: IOddDto, key: number, isSpecialFromSportOffer: boolean): Odd {
        const odd: Odd = new Odd();
        odd.id = dto.oi;
        odd.uuid = dto.uuid;
        odd.value = dto.ov;
        odd.marketId = dto.bgi;
        odd.marketTag = dto.sbgt;
        odd.marketCode = isSpecialFromSportOffer && !dto.bgc ? '0' : dto.bgc;
        odd.order = dto.oo;
        odd.status = dto.os || '';
        odd.marketOrder = dto.sbo;
        odd.offerType = dto.osi;
        odd.showSpecialBetStatus = dto.sbgs;
        odd.tags = dto.tags || '';
        odd.code = dto.oc;
        odd.groupId = dto.groupId;
        odd.specialBetValue = dto.osbv || '';
        odd.prefix = dto.prefix || '';
        odd.typeName = dto.ot;
        odd.name = dto.od || '';
        odd.specifiers = dto.spc;
        // fields for outrights
        odd.name = dto.name || '';
        odd.marketName = dto.marketName || '';
        return odd;
    }

    public map(source: IOddDto[], isSpecialFromSportOffer: boolean = false): Odd[] {
        return source.map((item, key) =>
            this.createTargetObject(item, key, isSpecialFromSportOffer)
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/mappers/offer/OddMapper.ts